import React, {useEffect, useState} from 'react';
import MediaLibraryManager from '../../Media/MediaLibraryManager';

function MediaChoice({kind, file, onChange}) {
    const [pickerOpen, setPickerOpen] = useState(false);
    const label = kind === 'image' ? 'Featured image' : 'Featured video';

    return <div className="content-featured-choice">
        <h3>{label}</h3>
        {file ? <>
            {kind === 'image'
                ? <img src={file.cdnUrl} alt={file.metadata?.altText || file.description || ''} />
                : <span className="content-media-file">{file.filename || 'Featured video'}</span>}
            <small>{file.filename}</small>
        </> : <p className="help">No {label.toLowerCase()} selected.</p>}
        <div className="content-media-actions">
            <button type="button" className="button small"
                onClick={() => setPickerOpen(true)}>Choose {kind}</button>
            {file && <button type="button" className="button small secondary"
                onClick={() => onChange(null, null)}>Remove</button>}
        </div>
        {pickerOpen && <MediaLibraryManager
            variant="modal"
            isOpen
            selectable
            accept={`${kind}/*`}
            title={`Choose ${label.toLowerCase()}`}
            onSelect={selected => {
                onChange(selected.id, selected);
                setPickerOpen(false);
            }}
            onCancel={() => setPickerOpen(false)}
        />}
    </div>;
}

export default function FeaturedMedia({image, video, imageId, videoId, onChange}) {
    const [selectedImage, setSelectedImage] = useState(image || null);
    const [selectedVideo, setSelectedVideo] = useState(video || null);

    useEffect(() => {
        if (!imageId) setSelectedImage(null);
        else if (image?.id === imageId) setSelectedImage(image);
    }, [image, imageId]);
    useEffect(() => {
        if (!videoId) setSelectedVideo(null);
        else if (video?.id === videoId) setSelectedVideo(video);
    }, [video, videoId]);

    return <section className="content-editor-panel" aria-labelledby="featured-media-title">
        <h2 id="featured-media-title">Featured media</h2>
        <p>Shown before the blog body on the storefront.</p>
        <div className="content-featured-grid">
            <MediaChoice kind="image" file={selectedImage} onChange={(id, file) => {
                setSelectedImage(file);
                onChange('imageId', id);
            }} />
            <MediaChoice kind="video" file={selectedVideo} onChange={(id, file) => {
                setSelectedVideo(file);
                onChange('videoId', id);
            }} />
        </div>
    </section>;
}
